module.exports = __webpack_public_path__ + "img/queue_card.323ed174.svg";